import { Editor } from "@tinymce/tinymce-react";
import React, { useState } from "react";

import axios from "axios";
import { URL } from "../../api/tklEnvironments";
import { store } from "../../App";
import { types } from "../../reducers/types";
import { mergeObjects } from "components/utility/ReUsableFunctions";
import "./_index.scss";

/**
 * Flag to disable autoselection of any image after it uploaded, in text editor
 */
window.tkl_image_uploaded_flag = false;

/**
 * Maximum file size limit for uploads (3 MB)
 */
const MAX_FILE_SIZE_MB = 3;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const FILE_SIZE_ERROR_MESSAGE = `File size exceeds the ${MAX_FILE_SIZE_MB} MB limit. Please choose a smaller file or use https://www.ilovepdf.com/compress_pdf to compress your file.`;

/*
  Note: We have included the plugin in the same JavaScript file as the TinyMCE
  instance for display purposes only. Tiny recommends not maintaining the plugin
  with the TinyMCE instance and using the `external_plugins` option.
*/

const ComponentWysiwygEditor = React.memo(function ComponentWysiwygEditor(
  props
) {
  const { type, height, contentHeight, readOnly } = props;
  const [editorId, setEditorId] = useState("");
  const [upload, setUpload] = useState(true);

  const disabledConfig = readOnly ? { readOnly: true, plugins: [], menubar: false, toolbar: false } : {};
  
  const uploadImageFile = (editor) => {
    editor.ui.registry.addButton('customImage', {
      text: '', // Optional: or 'Insert Image'
      icon: 'image',
      tooltip: 'Upload Image (.heic, .jpg, .jpeg, .png - Max 3 MB)',
      onAction: (first, second, third, fourth) => {
        const inputImageFile = document.getElementById("image-upload-tinymce");
        inputImageFile.click();

        inputImageFile.onchange = () => {
          const file = inputImageFile.files[0];
          if (!file) return;

          // Check file type - only allow heic, jpg, jpeg, png
          const fileExtension = file.name.split('.').pop().toLowerCase();
          const allowedExtensions = ['jpg', 'jpeg', 'png', 'heic', 'heif'];
          
          if (!allowedExtensions.includes(fileExtension)) {
            alert('Only image files are allowed: .heic, .jpg, .jpeg, .png');
            inputImageFile.value = '';
            return;
          }
          
          // Check file size limit (3 MB)
          if (file.size > MAX_FILE_SIZE_BYTES) {
            alert(FILE_SIZE_ERROR_MESSAGE);
            inputImageFile.value = '';
            return;
          }

          const reader = new FileReader();

          let formData = new FormData();
          formData.append("media[]", file);
          formData.append("type", "BANNER");
          store.dispatch({ type: types.SHOW_LOADER });
          axios
            .post(`${URL}/upload-media`, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then(function (response) {
              if (response.data) {
                window.tkl_image_uploaded_flag = true;

                store.dispatch({ type: types.HIDE_LOADER });
                const data = response.data?.response?.media[0];
                const newData = {};
                newData["name"] = data.name;
                newData["slug"] = data.slug;
                newData["url"] = data.url;
                const media_URL = `${URL}/stream-media/${data.slug}`;
                editor.insertContent(`<img width="100%" height="auto" src="${media_URL}" />`);
              }
            })
            .catch(function (error) {
              store.dispatch({ type: types.HIDE_LOADER });
              console.error("..error", error);
            });
        }
      }
    });
  };

  var openDialog = function (editor) {
    const dialogInstance = editor.windowManager.open({
      title: "Upload file",
      body: {
        type: "panel",
        items: [
          {
            type: "htmlpanel", // component type
            html: `
          <label for="input-text" class="p2 m-2" style="font-weight:bold">
          Title
          </label>
          <input style="border: 1px solid #cecece;width:100%;height: calc(1.5em + 0.5rem + 2px);"
          class="p-2 m-2 form-control form-control-sm rounded-pill"
           type="text" id="input-text"  name="text" value="">
          <label for="fileUpload" class="p2 m-2" style="font-weight:bold">
          Upload file
          </label>

          <input class="p-2 m-2 rounder-pill" type="file" id="fileUpload" name="avatar" accept=".txt,.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain" onchange="
            const errorDiv = document.getElementById('file-size-error');
            if (this.files[0] && this.files[0].size > ${MAX_FILE_SIZE_BYTES}) {
              errorDiv.style.display = 'block';
              this.value = '';
            } else {
              errorDiv.style.display = 'none';
            }
          ">
          <div id="file-size-error" style="display: none; margin: 8px; padding: 10px; background-color: #fee2e2; border: 1px solid #ef4444; border-radius: 4px; color: #dc2626; font-size: 13px;">
            <strong>⚠️ File too large!</strong><br>
            Maximum file size is 3 MB.<br>
            <span style="font-size: 12px;">To compress your PDF, visit: <a href="https://www.ilovepdf.com/compress_pdf" target="_blank" style="color: #dc2626;">ilovepdf.com/compress_pdf</a></span>
          </div>
          <p style="margin: 8px; font-size: 14px; font-weight: 600; color: #19a396;">
            .txt, .pdf, .doc, .docx file extensions are allowed - Max file size: 3 MB*
          </p>
          `,
            //<label for="avatar" class="p2 m-2">
            //Choose a File:</label>
            // <label for="display-name" class="p2 m-2">Display Name:</label><input class="p-2 m-2 rounder-pill"  type="text"  id="displayName"  name="avatar" >
          },
        ],
      },
      buttons: [
        {
          type: "cancel",
          text: "Close",
        },
        {
          type: "submit",
          text: "Save",
          primary: true,
        },
      ],
      onSubmit: async function (api) {
        var data = api.getData();
        const selectedFile = document.getElementById("fileUpload");
        let url = "www.google.com";
        const textPlaceholder = document.getElementById("input-text");
        /* Insert content when the window form is submitted */
        if (selectedFile?.files[0]) {
          var file = selectedFile?.files[0];
          
          // Check file size limit (3 MB)
          if (file.size > MAX_FILE_SIZE_BYTES) {
            const errorDiv = document.getElementById('file-size-error');
            if (errorDiv) {
              errorDiv.style.display = 'block';
            }
            selectedFile.value = '';
            return;
          }

          var reader = new FileReader();

          let formData = new FormData();
          formData.append("media[]", file);
          formData.append("type", "FILES");
          store.dispatch({ type: types.SHOW_LOADER });
          await axios
            .post(`${URL}/upload-media`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(function (response) {
              if (response.data) {
                store.dispatch({ type: types.HIDE_LOADER });
                let data = response.data?.response?.media[0];
                let newData = {};
                newData["name"] = data.name;
                newData["slug"] = data.slug;
                newData["url"] = data.url;
                let media_URL = `${URL}/stream-media/${data.slug}`;
                url = media_URL;
                //tkl-dev-course.com/api/v1/get-media/react-banner-png-2980600
                // http: reader.readAsDataURL(media_URL);
              }
            })
            .catch(function (error) {
              store.dispatch({ type: types.HIDE_LOADER });
              console.error("..error", error);
            });

          editor.insertContent(
            `<a href="${url}" style="cursor:pointer" target="_blank" download>${
              textPlaceholder?.value || "Default Text"
            }</a>`
          );
          setUpload(false);

          api.close();
        }
        // `<a href=${url} target="_blank">${textPlaceholder?.value}</a>`
      },
    });
    return dialogInstance;
  };

  const tklEditorConfigDefault = {
    initMinimal:{
      contentStyle: `
        img {float: none;margin:.5rem}

        table[style*="border-spacing"]:not([style*="border-spacing: 0"]) {
          border-collapse: separate !important;
        }
        
        /* Add these styles for scrollbar */
        body {
          overflow-y: auto !important;
          overflow-x: auto !important;
          max-height: 450px;
        }
      `,
      resize: true,
      min_height: 450,
    },
    initFull: {
      content_style: `
      img {float: none;margin:.5rem}

      table[style*="border-spacing"]:not([style*="border-spacing: 0"]) {
        border-collapse: separate !important;
      }
      
      /* Add these styles for scrollbar */
      body {
        overflow-y: auto !important;
        overflow-x: auto !important;
        max-height: ${contentHeight || 450}px;
      }

      /* Fix editor container height */
      .tox.tox-tinymce {
        height: ${contentHeight || 450}px !important;
      }`,
      min_height: contentHeight || 450,
      max_height: contentHeight || 450,
    },
    initLimited: {
      resize: true,
      content_style: `
      body {
        overflow-y: auto !important;
        overflow-x: auto !important;
        max-height: ${contentHeight || 450}px;
      }
    `,
    },
    communityMinimal: {
      content_style: `
      img {float: none;margin:.5rem}

      table[style*="border-spacing"]:not([style*="border-spacing: 0"]) {
        border-collapse: separate !important;
      }
      
      /* Add these styles for scrollbar */
      body {
        overflow-y: auto !important;
        overflow-x: auto !important;
        max-height: ${contentHeight || 450}px;
      }

      /* Fix editor container height */
      .tox.tox-tinymce {
        height: ${contentHeight || 450}px !important;
      }`,
      min_height: contentHeight || 450,
      max_height: contentHeight || 450,
    },
  };
  
  const tklEditorConfigActivityPath = {};

  const initMinimal = {
    imagetools_cors_hosts: ["picsum.photos"],
    menubar: "",
    // plugins: "emoticons",
    plugins: "lists link preview",
    toolbar:
      "undo redo bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | blockquote | outdent indent | numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile customImage media template link latex anchor codesample | ltr rtl | fontfamily fontsize blocks myCustomToolbarButton",
    toolbar_sticky: false,
    setup: (editor) => uploadImageFile(editor),
    autosave_ask_before_unload: false,
    media_alt_source: false,
    autosave_interval: "30s",
    autosave_prefix: "{path}{query}-{id}-",
    autosave_restore_when_empty: false,
    autosave_retention: "2m",
    image_advtab: true,
    // Indentation configuration
    indent_use_margin: false, // Use padding instead of margin for indentation
    tab_focus: ':prev,:next', // Allow tab navigation
    indentation: '30px', // Custom indentation size
    link_list: [
      {
        title: "My page 1",
        value: "http://www.tinymce.com",
      },
      {
        title: "My page 2",
        value: "http://www.moxiecode.com",
      },
    ],
    image_list: [
      {
        title: "My page 1",
        value: "http://www.tinymce.com",
      },
      {
        title: "My page 2",
        value: "http://www.moxiecode.com",
      },
    ],
    image_class_list: [
      {
        title: "None",
        value: "",
      },
      {
        title: "Some class",
        value: "class-name",
      },
    ],
    importcss_append: true,
    height: 250,
    // file_picker_callback: function (callback, value, meta) {
    //   /* Provide file and text for the link dialog */
    //   if (meta.filetype === "file") {
    //     callback("https://www.google.com/logos/google.jpg", {
    //       text: "Sample FIle",
    //     });
    //   }

    //   /* Provide image and alt text for the image dialog */
    //   if (meta.filetype === "image") {
    //     callback("https://www.google.com/logos/google.jpg", {
    //       alt: "Sample Image",
    //     });
    //   }

    //   /* Provide alternative source and posted for the media dialog */
    //   if (meta.filetype === "media") {
    //     callback("movie.mp4", {
    //       source2: "alt.ogg",
    //       poster: "https://www.google.com/logos/google.jpg",
    //     });
    //   }
    // },
    templates: [
      {
        title: "New Table",
        description: "creates a new table",
        content:
          '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
      },
      {
        title: "Starting my story",
        description: "A cure for writers block",
        content: "Once upon a time...",
      },
      {
        title: "New list with dates",
        description: "New List with dates",
        content:
          '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
      },
    ],
    template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
    template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
    image_caption: true,
    // quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    quickbars_selection_toolbar: "",
    noneditable_noneditable_class: "mceNonEditable",
    // toolbar_mode: 'sliding',
    toolbar_mode: "wrap",
    contextmenu: "link table",
    resize: false,
    // Disable branding message, remove "Powered by TinyMCE"
    branding: false,
  };

  const initFull = {
    // readonly: true,
    selector: "textarea",
    table_style_by_css: true,
    content_css: false,

    setup: (editor) => {
      // Register custom image upload button
      uploadImageFile(editor);
      
      editor.ui.registry.addButton("myCustomToolbarButton", {
        icon: "upload",
        id: "upload-file",
        onAction: () => {
          openDialog(editor);
        },
      });
      editor.ui.registry.addIcon(
        "myCustomToolbarButton",
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white"  viewBox="0 0 576 512"><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/> <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/> </svg>'
      );

      editor.on("init", function (e) {
        //console.log("editor_id:", e.target);
        setEditorId(e.target);
      });

      editor.on('SelectionChange', (elm) => {
        if (window.tkl_image_uploaded_flag === true) {
          window.tkl_image_uploaded_flag = false;
          editor.selection.collapse();
        }
      });
    },
    imagetools_cors_hosts: ["picsum.photos"],
    menubar: props.hideMenubar
      ? ""
      : "file edit view insert format tools table",
    plugins:
      "paste autoresize importcss searchreplace autolink autosave directionality code visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount textpattern noneditable help charmap quickbars",
    toolbar: `undo redo | formatting | justifyContent | mediaUpload myCustomToolbarButton link | leftToRight | optionColor | blockquote | outdent indent |  numlist bullist | optionsPrivew | fontfamily fontsize blocks`,
    toolbar_groups: {
      formatting: {
        icon: "format",
        tooltip: "Formatting",
        items: "bold italic underline strikethrough | superscript subscript",
      },
      justifyContent: {
        icon: "align-left",
        tooltip: "align-content",
        items: "alignleft aligncenter alignright alignjustify",
      },
      mediaUpload: {
        icon: "image",
        tooltip: "Upload-Media",
        items: "insertfile customImage media template anchor codesample",
      },
      leftToRight: {
        icon: "ltr",
        tooltip: "Left-Right",
        items: "ltr rtl",
      },
      optionColor: {
        icon: "text-color",
        tooltip: "color",
        items: "forecolor backcolor removeformat",
      },

      optionsPrivew: {
        icon: "fullscreen",
        tooltip: "Preview-Options",
        items: "preview fullscreen save print",
      },
      // fontSelectItem: {
      //   icon: "format",
      //   tooltip: "Font-Select",
      //   items: "fontselect fontsizeselect formatselect",
      // },
    },
    // toolbar:
    //   "bold italic underline | alignleft aligncenter alignright alignjustify | numlist bullist | save |image link myCustomToolbarButton| fontselect fontsizeselect formatselect | alignment",
    // toolbar_sticky: true,
    // toolbar:
    //   "undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | blockquote | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl | fontselect fontsizeselect formatselect | myCustomToolbarButton",

    autosave_ask_before_unload: true,
    media_alt_source: true,
    autosave_interval: "30s",
    autosave_prefix: "{path}{query}-{id}-",
    autosave_restore_when_empty: false,
    autosave_retention: "2m",
    image_advtab: true,
    // Indentation configuration
    indent_use_margin: false, // Use padding instead of margin for indentation
    tab_focus: ':prev,:next', // Allow tab navigation
    // Custom indentation size (default is 40px, setting to 30px)
    indentation: '30px',
    content_style: `
      img {float: none;margin:.5rem}

      table[style*="border-spacing"]:not([style*="border-spacing: 0"]) {
        border-collapse: separate !important;
      }
      
      /* Better indentation styles */
      .mce-indent-1 { padding-left: 30px !important; }
      .mce-indent-2 { padding-left: 60px !important; }
      .mce-indent-3 { padding-left: 90px !important; }
      .mce-indent-4 { padding-left: 120px !important; }
      .mce-indent-5 { padding-left: 150px !important; }`,

    link_list: [
      {
        title: "My page 1",
        value: "http://www.tinymce.com",
      },
      {
        title: "My page 2",
        value: "http://www.moxiecode.com",
      },
    ],
    image_list: [
      {
        title: "My page 1",
        value: "http://www.tinymce.com",
      },
      {
        title: "My page 2",
        value: "http://www.moxiecode.com",
      },
    ],
    image_class_list: [
      {
        title: "None",
        value: "",
      },
      {
        title: "Some class",
        value: "class-name",
      },
    ],
    importcss_append: true,
    min_height: contentHeight || 560,
    default_link_target: "_blank",
    file_picker_types: "document file image",
    file_picker_callback: (callback, value, meta) => {
      if (meta.filetype === "image") {
        //console.log("callback  :", callback);
        var input = document.getElementById("image-upload-tinymce");
        input.click();

        input.onchange = () => {
          var file = input.files[0];
          if (!file) return;

          // Check file type - only allow heic, jpg, jpeg, png
          const fileExtension = file.name.split('.').pop().toLowerCase();
          const allowedExtensions = ['jpg', 'jpeg', 'png', 'heic', 'heif'];
          
          if (!allowedExtensions.includes(fileExtension)) {
            alert('Only image files are allowed: .heic, .jpg, .jpeg, .png');
            input.value = '';
            return;
          }
          
          // Check file size limit (3 MB)
          if (file.size > MAX_FILE_SIZE_BYTES) {
            alert(FILE_SIZE_ERROR_MESSAGE);
            input.value = '';
            return;
          }

          var reader = new FileReader();

          let formData = new FormData();
          formData.append("media[]", file);
          formData.append("type", "BANNER");
          store.dispatch({ type: types.SHOW_LOADER });
          axios
            .post(`${URL}/upload-media`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(function (response) {
              if (response.data) {
                window.tkl_image_uploaded_flag = true;

                store.dispatch({ type: types.HIDE_LOADER });
                let data = response.data?.response?.media[0];
                let newData = {};
                newData["name"] = data.name;
                newData["slug"] = data.slug;
                newData["url"] = data.url;
                let media_URL = `${URL}/stream-media/${data.slug}`;
                callback(media_URL, {
                  alt: data.name,
                  slug: data.slug,
                });

                //tkl-dev-course.com/api/v1/get-media/react-banner-png-2980600
                http: reader.readAsDataURL(media_URL);
              }
            })
            .catch(function (error) {
              store.dispatch({ type: types.HIDE_LOADER });
              console.error("..error", error);
            });

          // reader.onload = (e) => {
          //   var img = new Image();
          //   img.src = reader.result;

          //   callback(e.target.result, {
          //     alt: file.name,
          //   });

          //   //delay();
          // };
        };
      } else {
        //console.log("value:::value :  ", meta);
      }
    },

    templates: [
      {
        title: "New Table",
        description: "creates a new table",
        content:
          '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
      },
      {
        title: "Starting my story",
        description: "A cure for writers block",
        content: "Once upon a time...",
      },
      {
        title: "New list with dates",
        description: "New List with dates",
        content:
          '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
      },
      {
        title: "Two Coloum Div",
        description: "Two Colom Div",
        content:
          '<div style="box-sizing: border-box;content:"";display: table;clear: both;border:1px solid"> <div style="box-sizing: border-box;float: left;width:50%;padding:10px;"> Sample 1</div> <div style="box-sizing: border-box;float: left;width:50%;padding:10px;"> Sample 2</div> </div>',
      },
      {
        title: "Two Coloum table Borderless",
        description: "Two Colom Div",
        content:
          '<table style="width: 100%;border: none;"> <tr> <td style="width: 50%;border: hidden;">Column 1</td> <td style="width: 50%;border: hidden;">Column 2</td> </tr> </table>',
      },
      {
        title: "Two Coloum With Background",
        description: "Two Colom Div",
        content:
          '<table style="width: 100%;border: none;background-color:lightgray;"> <tr> <td style="width: 50%;border: hidden;background:">Heading 1</td> <td style="width: 50%;border: hidden;">Heading 2</td> </tr> </table>',
      },
    ],
    template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
    template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
    image_caption: true,
    // quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    quickbars_selection_toolbar: "",
    noneditable_noneditable_class: "mceNonEditable",
    // toolbar_mode: 'sliding',
    // toolbar_mode: "wrap",
    contextmenu: "link table",
    resize: false,
    // Disable branding message, remove "Powered by TinyMCE"
    branding: false,
  };

  const initLimited = {
    //height: "350px",
    readonly: true,
    imagetools_cors_hosts: ["picsum.photos"],
    // plugins: "file  emoticons", //image link media
    toolbar:
      "undo redo bold italic underline strikethrough | blockquote |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen save|  template link codesample | ltr rtl | fontfamily fontsize blocks", //insertfile image media
    toolbar_sticky: true,
    autosave_ask_before_unload: true,
    media_alt_source: false,
    autosave_interval: "30s",
    autosave_prefix: "{path}{query}-{id}-",
    autosave_restore_when_empty: false,
    autosave_retention: "2m",
    image_advtab: true,
    // Indentation configuration
    indent_use_margin: false, // Use padding instead of margin for indentation
    tab_focus: ':prev,:next', // Allow tab navigation
    indentation: '30px', // Custom indentation size

    link_list: [],
    image_list: [
      {
        title: "My page 1",
        value: "http://www.tinymce.com",
      },
      {
        title: "My page 2",
        value: "http://www.moxiecode.com",
      },
    ],
    image_class_list: [
      {
        title: "None",
        value: "",
      },
      {
        title: "Some class",
        value: "class-name",
      },
    ],
    importcss_append: true,
    // height: 150,
    // file_picker_callback: function (callback, value, meta) {
    //   /* Provide file and text for the link dialog */
    //   if (meta.filetype === "file") {
    //     callback("https://www.google.com/logos/google.jpg", {
    //       text: "Sample FIle",
    //     });
    //   }

    //   /* Provide image and alt text for the image dialog */
    //   if (meta.filetype === "image") {
    //     callback("https://www.google.com/logos/google.jpg", {
    //       alt: "Sample Image",
    //     });
    //   }

    //   /* Provide alternative source and posted for the media dialog */
    //   if (meta.filetype === "media") {
    //     callback("movie.mp4", {
    //       source2: "alt.ogg",
    //       poster: "https://www.google.com/logos/google.jpg",
    //     });
    //   }
    // },
    // templates: [
    //   {
    //     title: "New Table",
    //     description: "creates a new table",
    //     content:
    //       '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
    //   },
    //   {
    //     title: "Starting my story",
    //     description: "A cure for writers block",
    //     content: "Once upon a time...",
    //   },
    //   {
    //     title: "New list with dates",
    //     description: "New List with dates",
    //     content:
    //       '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
    //   },
    //   {
    //     title: "Two Coloum Div",
    //     description: "Two Colom Div",
    //     content:
    //       '<div style="box-sizing: border-box;content:"";display: table;clear: both;border:1px solid"> <div style="box-sizing: border-box;float: left;width:50%;padding:10px;"> Sample 1</div> <div style="box-sizing: border-box;float: left;width:50%;padding:10px;"> Sample 2</div> </div>',
    //   },
    //   {
    //     title: "Two Coloum table Borderless",
    //     description: "Two Colom Div",
    //     content:
    //       '<table style="width: 100%;border: none;"> <tr> <td style="width: 50%;border: hidden;">Column 1</td> <td style="width: 50%;border: hidden;">Column 2</td> </tr> </table>',
    //   },
    //   {
    //     title: "Two Coloum With Background",
    //     description: "Two Colom Div",
    //     content:
    //       '<table style="width: 100%;border: none;background-color:lightgray;"> <tr> <td style="width: 50%;border: hidden;background:">Heading 1</td> <td style="width: 50%;border: hidden;">Heading 2</td> </tr> </table>',
    //   },
    // ],
    // template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
    // template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
    // image_caption: true,
    // // quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    // quickbars_selection_toolbar: "",
    // noneditable_noneditable_class: "mceNonEditable",
    // // toolbar_mode: 'sliding',
    // toolbar_mode: "wrap",
    // contextmenu: "link table",
    // resize: false,
    // // Disable branding message, remove "Powered by TinyMCE"
    // branding: false,

    file_picker_callback: (callback, value, meta) => {
      if (meta.filetype === "image") {
        //console.log("callback  :", callback);
        var input = document.getElementById("image-upload-tinymce");
        input.click();

        input.onchange = () => {
          var file = input.files[0];
          if (!file) return;

          // Check file type - only allow heic, jpg, jpeg, png
          const fileExtension = file.name.split('.').pop().toLowerCase();
          const allowedExtensions = ['jpg', 'jpeg', 'png', 'heic', 'heif'];
          
          if (!allowedExtensions.includes(fileExtension)) {
            alert('Only image files are allowed: .heic, .jpg, .jpeg, .png');
            input.value = '';
            return;
          }
          
          // Check file size limit (3 MB)
          if (file.size > MAX_FILE_SIZE_BYTES) {
            alert(FILE_SIZE_ERROR_MESSAGE);
            input.value = '';
            return;
          }

          var reader = new FileReader();

          let formData = new FormData();
          formData.append("media[]", file);
          formData.append("type", "BANNER");

          axios
            .post(`${URL}/upload-media`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(function (response) {
              if (response.data) {
                let data = response.data?.response?.media[0];
                let newData = {};
                newData["name"] = data.name;
                newData["slug"] = data.slug;
                newData["url"] = data.url;
                let media_URL = `${URL}/stream-media/${data.slug}`;
                callback(media_URL, {
                  alt: data.name,
                  slug: data.slug,
                });
                reader.readAsDataURL(media_URL);
              }
            })
            .catch(function (error) {
              console.error("..error", error);
            });
        };
      } else {
        //console.log("value:::value :  ", meta);
      }
    },

    templates: [
      {
        title: "New Table",
        description: "creates a new table",
        content:
          '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
      },
      {
        title: "Starting my story",
        description: "A cure for writers block",
        content: "Once upon a time...",
      },
      {
        title: "New list with dates",
        description: "New List with dates",
        content:
          '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
      },
      {
        title: "Two Coloum Div",
        description: "Two Colom Div",
        content:
          '<div style="box-sizing: border-box;content:"";display: table;clear: both;border:1px solid"> <div style="box-sizing: border-box;float: left;width:50%;padding:10px;"> Sample 1</div> <div style="box-sizing: border-box;float: left;width:50%;padding:10px;"> Sample 2</div> </div>',
      },
      {
        title: "Two Coloum table Borderless",
        description: "Two Colom Div",
        content:
          '<table style="width: 100%;border: none;"> <tr> <td style="width: 50%;border: hidden;">Column 1</td> <td style="width: 50%;border: hidden;">Column 2</td> </tr> </table>',
      },
      {
        title: "Two Coloum With Background",
        description: "Two Colom Div",
        content:
          '<table style="width: 100%;border: none;background-color:lightgray;"> <tr> <td style="width: 50%;border: hidden;background:">Heading 1</td> <td style="width: 50%;border: hidden;">Heading 2</td> </tr> </table>',
      },
    ],
    template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
    template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
    image_caption: true,
    // quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    quickbars_selection_toolbar: "",
    noneditable_noneditable_class: "mceNonEditable",
    // toolbar_mode: 'sliding',
    toolbar_mode: "wrap",
    contextmenu: "link table",
    resize: true,
    // Disable branding message, remove "Powered by TinyMCE"
    branding: false,
  };

  const communityMinimal = {
    setup: (editor) => uploadImageFile(editor),
    //height: "350px",
    readonly: true,
    menubar: '',
    // plugins: "file  emoticons", //image link media
    plugins: "advlist lists",
    toolbar: 
      'undo redo | formatting | optionColor | blockquote | justifyContent | outdent indent | numlist bullist',
    toolbar_groups: {
      formatting: {
        icon: "format",
        tooltip: "Formatting",
        items: "bold italic underline strikethrough | superscript subscript",
      },
      justifyContent: {
        icon: "align-left",
        tooltip: "align-content",
        items: "alignleft aligncenter alignright alignjustify",
      },
      optionColor: {
        icon: "text-color",
        tooltip: "color",
        items: "forecolor backcolor removeformat",
      },
    },
    autosave_ask_before_unload: true,
    autosave_interval: "30s",
    autosave_prefix: "{path}{query}-{id}-",
    autosave_restore_when_empty: false,
    autosave_retention: "2m",

    // quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    resize: true,
    // Disable branding message, remove "Powered by TinyMCE"
    branding: false,
  };

  const communityPostText = {
    toolbar: 
      'undo redo | formatting | optionColor | blockquote | justifyContent | outdent indent | numlist bullist | customImage',
  };

  const communityPostImage = {
    setup: (editor) => {
      uploadImageFile(editor);
      editor.on('keydown', (e) => {
        // Disallow typing text (allow only media dialog and toolbar interactions)
        if (!e.ctrlKey && !e.metaKey && e.key !== 'Delete' && e.key !== 'Backspace') {
          e.preventDefault();
        }
      });

      editor.on('paste', (e) => e.preventDefault());
    },
    toolbar: 
      'customImage',
  };

  // const communityPostVideo = {
  //   setup: (editor) => {
  //     uploadImageFile(editor);
  //     editor.on('keydown', (e) => {
  //       // Disallow typing text (allow only media dialog and toolbar interactions)
  //       if (!e.ctrlKey && !e.metaKey && e.key !== 'Delete' && e.key !== 'Backspace') {
  //         e.preventDefault();
  //       }
  //     });

  //     editor.on('paste', (e) => e.preventDefault());
  //   },
  //   toolbar: 
  //     'customImage',
  // };

  const communityPostVideo = {
    // readonly: true,
    selector: "textarea",
    table_style_by_css: true,
    content_css: false,

    setup: (editor) => {
      editor.on("init", function (e) {
        //console.log("editor_id:", e.target);
        setEditorId(e.target);
      });

      editor.on('BeforeSetContent', (e) => {
        // Get the current content as text and remove whitespace
        const currentTextContent = editor.getContent({ format: 'text' }).replace(/\s/g, '');
        const hasVideo = /<iframe|<video/i.test(editor.getContent({ format: 'html' }));
        const isTryingToInsertVideo = /<iframe|<video/i.test(e.content);
        // Only block if there is already a video in the editor and it's not empty
        if (hasVideo && isTryingToInsertVideo && currentTextContent.length > 0) {
          e.preventDefault();
          alert('Only one video is allowed.');
        }
      });

      editor.on('keydown', (e) => {
        // Disallow typing text (allow only media dialog and toolbar interactions)
        if (!e.ctrlKey && !e.metaKey && e.key !== 'Delete' && e.key !== 'Backspace') {
          e.preventDefault();
        }
      });

      editor.on('paste', (e) => e.preventDefault());

      // Center videos after inserting them
      editor.on('SetContent', () => {
        const videos = editor.dom.select('video');
        videos.forEach(video => {
          editor.dom.setStyle(video, 'display', 'block');
          editor.dom.setStyle(video, 'margin', '0 auto');
        });
      });

      // When a media element is inserted, force center it
      editor.on('ObjectResized MediaInsert', () => {
        const videos = editor.dom.select('video');
        videos.forEach(video => {
          editor.dom.setStyle(video, 'display', 'block');
          editor.dom.setStyle(video, 'margin', '0 auto');
        });
      });
    },
    imagetools_cors_hosts: ["picsum.photos"],
    menubar: false,
    plugins: ['media', 'link'], // keep plugins as needed
    toolbar: '', // Remove the media button from the toolbar
    // Center the video by default
    content_style: `    video {
      display: block;
      margin: 0 auto;
      max-width: 100%;
      height: auto;
    }
    .mce-content-body {
      text-align: center;
    }
    /* Add these styles for scrollbar */
    body {
      overflow-y: auto !important;
      overflow-x: auto !important;
      display: block;
      margin: 0 auto;
      max-width: 100%;
      height: auto;
    }
    `,
    autosave_ask_before_unload: true,
    media_alt_source: true,
    autosave_interval: "30s",
    autosave_prefix: "{path}{query}-{id}-",
    autosave_restore_when_empty: false,
    autosave_retention: "2m",
    image_advtab: true,
    // Indentation configuration
    indent_use_margin: false, // Use padding instead of margin for indentation
    tab_focus: ':prev,:next', // Allow tab navigation
    indentation: '30px', // Custom indentation size
    importcss_append: true,
    min_height: contentHeight || 560,
    default_link_target: "_blank",
    file_picker_types: "document file image",
    file_picker_callback: (callback, value, meta) => {
      if (meta.filetype === "image") {
        //console.log("callback  :", callback);
        var input = document.getElementById("image-upload-tinymce");
        input.click();

        input.onchange = () => {
          var file = input.files[0];
          if (!file) return;

          // Check file type - only allow heic, jpg, jpeg, png
          const fileExtension = file.name.split('.').pop().toLowerCase();
          const allowedExtensions = ['jpg', 'jpeg', 'png', 'heic', 'heif'];
          
          if (!allowedExtensions.includes(fileExtension)) {
            alert('Only image files are allowed: .heic, .jpg, .jpeg, .png');
            input.value = '';
            return;
          }
          
          // Check file size limit (3 MB)
          if (file.size > MAX_FILE_SIZE_BYTES) {
            alert(FILE_SIZE_ERROR_MESSAGE);
            input.value = '';
            return;
          }

          var reader = new FileReader();

          let formData = new FormData();
          formData.append("media[]", file);
          formData.append("type", "BANNER");
          store.dispatch({ type: types.SHOW_LOADER });
          axios
            .post(`${URL}/upload-media`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(function (response) {
              if (response.data) {
                window.tkl_image_uploaded_flag = true;

                store.dispatch({ type: types.HIDE_LOADER });
                let data = response.data?.response?.media[0];
                let newData = {};
                newData["name"] = data.name;
                newData["slug"] = data.slug;
                newData["url"] = data.url;
                let media_URL = `${URL}/stream-media/${data.slug}`;
                callback(media_URL, {
                  alt: data.name,
                  slug: data.slug,
                });

                //tkl-dev-course.com/api/v1/get-media/react-banner-png-2980600
                http: reader.readAsDataURL(media_URL);
              }
            })
            .catch(function (error) {
              store.dispatch({ type: types.HIDE_LOADER });
              console.error("..error", error);
            });

          // reader.onload = (e) => {
          //   var img = new Image();
          //   img.src = reader.result;

          //   callback(e.target.result, {
          //     alt: file.name,
          //   });

          //   //delay();
          // };
        };
      } else {
        //console.log("value:::value :  ", meta);
      }
    },

    templates: [],
    template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
    template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
    image_caption: true,
    // quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    quickbars_selection_toolbar: "",
    noneditable_noneditable_class: "mceNonEditable",
    // toolbar_mode: 'sliding',
    // toolbar_mode: "wrap",
    contextmenu: "link table",
    resize: false,
    // Disable branding message, remove "Powered by TinyMCE"
    branding: false,
  };

  const handleEditorChange = (value) => {
    if (upload) props.courseDescriptionChangeHandler(value, editorId);
    setUpload(true);
  };

  const loadCustomConfigByUrl = (typeEditor) => {
    let configByTypeEditor = 'initMinimal';
    if (typeEditor === 'full') {
      configByTypeEditor = 'initFull';
    } else if (typeEditor === 'initLimited') {
      configByTypeEditor = 'initLimited';
    } else if (typeEditor === 'communityMinimal') {
      configByTypeEditor = 'communityMinimal';
    } else if (typeEditor === 'communityPostImage') {
      configByTypeEditor = 'communityMinimal';
    } else if (typeEditor === 'communityPostText') {
      configByTypeEditor = 'communityMinimal';
    } else if (typeEditor === 'communityPostVideo') {
      configByTypeEditor = 'communityMinimal';
    }

    if (/\/activity\-path\/edit/i.test(window.location.href)) {
      return tklEditorConfigActivityPath;
    }

    return tklEditorConfigDefault[configByTypeEditor];
  };

  const getInitConfig = (typeEditor) => {
    const customConfig = loadCustomConfigByUrl(typeEditor);
    if (typeEditor === "full") {
      return mergeObjects(initFull, customConfig);
      
    } else if (typeEditor === "initLimited") {
      return mergeObjects(initLimited, customConfig);
    } else if (typeEditor === "communityMinimal") {
      return mergeObjects(communityMinimal, customConfig);
    } else if (typeEditor === "communityPostImage") {
      return mergeObjects(
        mergeObjects(communityMinimal, communityPostImage),
        customConfig
      );
    } else if (typeEditor === "communityPostText") {
      return mergeObjects(
        mergeObjects(communityMinimal, communityPostText),
        customConfig
      );
    } else if (typeEditor === "communityPostVideo") {
      return mergeObjects(
        mergeObjects(communityMinimal, communityPostVideo),
        customConfig
      );
    }

    return mergeObjects(initMinimal, customConfig);
  }

  return (
    <>
      <input
        type="file"
        id="image-upload-tinymce"
        name="single-image"
        style={{ display: "none" }}
        accept=".heic,.heif,.jpg,.jpeg,.png,image/heic,image/heif,image/jpeg,image/png"
      />
      <Editor
        // initialValue="<img title='TinyMCE Logo' src='//www.tiny.cloud/images/glyph-tinymce@2x.png' alt='TinyMCE Logo' width='110' height='97' /> </p> <h2 style='text-align: center;'>Welcome to the TinyMCE Cloud demo!</h2> <p>Please try out the features provided in this full featured example (excluding <a href='https://www.tiny.cloud/apps/'>Premium Plugins</a> ).</p> <h2>Got questions or need help?</h2> <ul> <li>Our <a class='mceNonEditable' href='//www.tiny.cloud/docs/'>documentation</a> is a great resource for learning how to configure TinyMCE.</li> <li>Have a specific question? Visit the <a class='mceNonEditable' href='https://community.tiny.cloud/forum/'>Community Forum</a>.</li> <li>We also offer enterprise grade support as part of <a href='https://www.tiny.cloud/pricing'>TinyMCE premium plans</a>.</li> </ul> <h2>A simple table to play with</h2> <table style='text-align: center;border-collapse: collapse; width: 100%;'> <thead> <tr> <th>Product</th> <th>Cost</th> <th>Really?</th> </tr> </thead> <tbody> <tr> <td>TinyMCE Cloud</td> <td>Get started for free</td> <td>YES!</td> </tr> <tr> <td>Plupload</td> <td>Free</td> <td>YES!</td> </tr> </tbody> </table> <h2>Found a bug?</h2> <p>If you think you have found a bug please create an issue on the <a href='https://github.com/tinymce/tinymce/issues'>GitHub repo</a> to report it to the developers.</p> <h2>Finally ...</h2> <p>Don't forget to check out our other product <a href='http://www.plupload.com' target='_blank'>Plupload</a>, your ultimate upload solution featuring HTML5 upload support.</p> <p>Thanks for supporting TinyMCE! We hope it helps you and your users create great content.<br>All the best from the TinyMCE team.</p>"
        tinymceScriptSrc='/tinymce/tinymce.min.js'
        licenseKey='T7LK09615AA278F7F7D34F9429B8A2B4D3A77F0FCF04AAB84A64AC5289800A6F'
        className={type === "full" ? "wysiwyg-full" : "wysiwyg-minimal"}
        init={mergeObjects(getInitConfig(type), disabledConfig)}
        disabled={readOnly}
        value={props.editorValue}
        onEditorChange={handleEditorChange}
      />
    </>
  );
});

export default ComponentWysiwygEditor;

